<div class="actions-wrapper">
	<span class="freud-icon freud-icon-dots" (click)="toggleActionsMenu(true)"></span>
	<div *ngIf="isOpen" class="actions-menu" #actions_menu>
		<div class="actions-menu__item"  (click)="toggleActionsMenu(false);onChatClick.emit()">
			<span>{{'CONTACT.OPEN_CHAT' | translate}}</span>
		</div>
		<div class="actions-menu__item" (click)="toggleActionsMenu(false);onScheduleClick.emit()">
			<span>{{'CONTACT.SCHEDULE' | translate}}</span>
		</div>
		<div class="actions-menu__item" (click)="toggleActionsMenu(false);onEditClick.emit()">
			<span>{{'CONTACT.EDIT_PROFILE' | translate}}</span>
		</div>
	</div>
</div>
